import React, { useState, useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate
} from 'react-router-dom';

import Sidebar from './components/Sidebar';
import Inventory from './components/Inventory';
import PosBilling from './components/PosBilling';
import Transactions from './components/Transactions';
import LoginPage from './components/LoginPage';
import AdvertisementPage from './components/AdvertisementPage';
import AdvertisementManager from './components/AdvertisementManager';


// ================= DASHBOARD =================
function Dashboard({ user, setLoggedIn }) {

  const [activeTab, setActiveTab] =
    useState('inventory');

  const [activeModule, setActiveModule] =
    useState('nursery');

  const [isSidebarOpen, setIsSidebarOpen] =
    useState(true);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    setLoggedIn(false);
    navigate('/login');
  };

  const renderContent = () => {
    if (activeModule === 'marketing') {
      return <AdvertisementManager />;
    }

    switch (activeTab) {

      case 'inventory':
        return <Inventory user={user} />;

      case 'pos-billing':
        return <PosBilling />;

      case 'transactions':
        return <Transactions />;

      default:
        return (
          <div style={{ background: '#fff', padding: 30, borderRadius: 12 }}>
            <h3>{activeTab} Module</h3>
          </div>
        );
    }
  };

  return (
    <div style={appStyle}>

      <Sidebar
        activeModule={activeModule}
        setActiveModule={setActiveModule}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        handleLogout={handleLogout}
      />

      <div style={mainWrapperStyle(isSidebarOpen)}>



        <main style={mainStyle}>
          {renderContent()}
        </main>

      </div>

    </div>
  );
}


// ================= APP =================
function App() {

  const [loggedIn, setLoggedIn] = useState(
    !!localStorage.getItem('token')
  );

  const [user, setUser] = useState(() => {
    const u = localStorage.getItem('user');
    return u ? JSON.parse(u) : null;
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    const u = localStorage.getItem('user');
    setLoggedIn(!!token);
    setUser(u ? JSON.parse(u) : null);
  }, []);

  return (
    <BrowserRouter basename="/nursery">

      <Routes>

        {/* PUBLIC ADVERTISEMENT PAGE - No login required */}
        <Route
          path="/home"
          element={<AdvertisementPage />}
        />

        {/* LOGIN */}
        <Route
          path="/login"
          element={
            loggedIn
              ? <Navigate to="/" />
              : <LoginPage setLoggedIn={setLoggedIn} />
          }
        />

        <Route
          path="/*"
          element={
            loggedIn
              ? <Dashboard user={user} setLoggedIn={setLoggedIn} />
              : <Navigate to="/login" />
          }
        />

      </Routes>

    </BrowserRouter>
  );
}


// ================= STYLES =================
const appStyle = {
  display: 'flex',
  height: '100vh',
  background: '#f8fafc',
  overflow: 'hidden',
  margin: 0,
};

const mainWrapperStyle = (isSidebarOpen) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  paddingLeft: isSidebarOpen ? '0' : '52px',
  transition: 'padding-left 0.3s ease',
});

const mainStyle = {
  flex: 1,
  overflowY: 'auto',
  padding: '30px',
};

export default App;
